import { render, staticRenderFns } from "./TooltipWithGlossary.vue?vue&type=template&id=ebe7b7e4&scoped=true"
import script from "./TooltipWithGlossary.vue?vue&type=script&lang=js"
export * from "./TooltipWithGlossary.vue?vue&type=script&lang=js"
import style0 from "./TooltipWithGlossary.vue?vue&type=style&index=0&id=ebe7b7e4&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe7b7e4",
  null
  
)

export default component.exports